import React from 'react'
import { Link } from 'react-router-dom'
import TrialLock from '../components/TrialLock'
import '../styles/ComingSoon.scss'

const NotFoundPage: React.FC = () => {
    return (
        <main className="recovery-page" aria-labelledby="not-found-title">
            <section className="recovery-card">
                <p className="recovery-eyebrow">Error 404</p>
                <h1 id="not-found-title">We could not find that page</h1>
                <p className="recovery-message">
                    The link may be out of date, or the page may have moved. Use the dashboard to continue managing your cloud resources.
                </p>
                <div className="recovery-actions">
                    <Link className="recovery-action recovery-action--primary" to="/">
                        Go to dashboard
                    </Link>
                    <TrialLock locked={false} paidResource><Link className="recovery-action" to="/deploy">
                        Explore resources
                    </Link></TrialLock>
                </div>
                <a className="recovery-support" href="https://docs.redu.cloud" target="_blank" rel="noopener noreferrer">
                    Open documentation
                </a>
            </section>
        </main>
    )
}

export default NotFoundPage
